export enum DeliveryColor {
  FullDelivery = '#b3ff99',
  PartlyDelivery = '#fdfd96',
  ToHighDelivery = '#ffb2b2',
  ShortDateDelivery = '#000000',
}
